import React from "react";

import { Switch, Route, withRouter } from "react-router-dom";

import "../../../styles/css/App.css";

import Business from "./business/business"
import Accommodations from "./accommodations/accommodations"
import PharmacyDuties from "./pharmacies/duties"
import Institutions from "./institutions/institutions"
import OpenAir from "./open-air/open-air"
import Culture from "./culture/culture"

function Router( { history, base } ) {
  
  return (
    <Switch>
      <Route path={`${base}/business`}>
        <Business />
      </Route>
      <Route path={`${base}/accommodations`}>
        <Accommodations />
      </Route>
       <Route path={`${base}/cultural-spaces`}>
        <Culture />
      </Route>
      <Route path={`${base}/institutions`}>
        <Institutions />
      </Route>
      <Route path={`${base}/open-air`}>
        <OpenAir />
      </Route>
      <Route path={`${base}/pharmacy-duties`}>
        <PharmacyDuties />
      </Route>
    </Switch>
  );

}

export default withRouter(Router);
